import clsx from "clsx";
import type { ReactNode } from "react";

export interface StatTileProps {
  label: ReactNode;
  value: ReactNode;
  /** Small line under the value, e.g. "3 av 7 rätt". */
  hint?: ReactNode;
  icon?: ReactNode;
  tone?: "neutral" | "accent" | "success" | "warning";
  className?: string;
}

const TONES = {
  neutral: "text-ink-900 dark:text-ink-50",
  accent: "text-accent-700 dark:text-accent-300",
  success: "text-green-700 dark:text-green-300",
  warning: "text-amber-700 dark:text-amber-300",
};

export function StatTile({ label, value, hint, icon, tone = "neutral", className }: StatTileProps) {
  return (
    <div className={clsx("surface print-plain flex items-start gap-3 p-4", className)}>
      {icon && <div className="mt-0.5 text-ink-400 dark:text-ink-500">{icon}</div>}
      <div>
        <div className="text-xs font-medium uppercase tracking-wide text-ink-500 dark:text-ink-400">
          {label}
        </div>
        <div className={clsx("font-display text-2xl tabular-nums", TONES[tone])}>{value}</div>
        {hint && <div className="text-xs text-ink-500 dark:text-ink-400">{hint}</div>}
      </div>
    </div>
  );
}
